
import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import AppProviders from './components/app/AppProviders';
import AppRoutes from './components/app/AppRoutes';
import { MotionConfig } from 'framer-motion';

// Inner component that has access to Redux store  
const AppContent: React.FC = () => {
  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <AppRoutes />
      </MotionConfig>
    </BrowserRouter>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
};

export default App;
